module.exports = __webpack_public_path__ + "img/seekingsimple2.b5909ae3.webp";